import logo from "./lat-med-logo.png";

export { logo };
